import { Component, OnInit } from '@angular/core';
import {InvoiceTemplateBase} from '../invoce-template-base';

@Component({
  selector: 'eci-export-invoice-form',
  templateUrl: './export-invoice-form.component.html',
  styleUrls: ['./export-invoice-form.component.scss']
})
export class ExportInvoiceFormComponent extends InvoiceTemplateBase  implements OnInit {

  ngOnInit(): void {
      this.model = {
          ...this.template,
          ...this.invoice,
          customerCompany: {
              ...this.template.customerCompany,
              ...this.invoice.customerCompany
          }
      };
  }

}
